/* Congelados.cl — comportamiento del tema */
(function () {
  'use strict';

  /* ---------------- Cajones móviles ---------------- */

  // Hay más de uno por página (menú y filtros), así que el botón declara
  // cuál abre con aria-controls. Buscar «el primer cajón» abría siempre
  // el del menú, aunque el clic viniera del botón de filtros.
  var abierto = null;
  var disparador = null;

  // `boton` es lo que recibe el foco al cerrar. El mini carrito no tiene
  // botón que lo abra: se abre al agregar un producto, desde el de agregar.
  var abrirCajon = function (el, boton) {
    if (!el) return;
    if (abierto && abierto !== el) cerrarCajon();

    abierto = el;
    disparador = boton;
    el.classList.add('is-open');
    if (boton && boton.hasAttribute('aria-controls')) boton.setAttribute('aria-expanded', 'true');
    // Sin esto la página de atrás sigue desplazándose bajo el cajón
    document.body.style.overflow = 'hidden';
    var panel = el.querySelector('.drawer__panel');
    if (panel) panel.focus();
  };

  var cerrarCajon = function () {
    if (!abierto) return;

    abierto.classList.remove('is-open');
    document.body.style.overflow = '';
    if (disparador) {
      if (disparador.hasAttribute('aria-controls')) disparador.setAttribute('aria-expanded', 'false');
      disparador.focus();
    }
    abierto = null;
    disparador = null;
  };

  document.addEventListener('click', function (event) {
    var abrir = event.target.closest('[data-drawer-open]');
    if (abrir) return abrirCajon(document.getElementById(abrir.getAttribute('aria-controls')), abrir);
    if (event.target.closest('[data-drawer-close]')) cerrarCajon();
  });

  document.addEventListener('keydown', function (event) {
    if (!abierto) return;
    if (event.key === 'Escape') return cerrarCajon();
    if (event.key !== 'Tab') return;

    // El foco no debe escaparse a la página de atrás mientras está abierto
    var panel = abierto.querySelector('.drawer__panel');
    var focusables = panel.querySelectorAll(
      'a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // Al pasar a escritorio el menú y los filtros dejan de ir en cajón: hay que
  // soltar el scroll. El mini carrito sí existe en escritorio y sigue abierto.
  window.matchMedia('(min-width: 901px)').addEventListener('change', function (e) {
    if (e.matches && abierto && !abierto.hasAttribute('data-cart-drawer')) cerrarCajon();
  });

  /* ---------------- Filtros y orden de colección ---------------- */

  // El formulario funciona solo: sin JS el visitante marca y aprieta
  // «Aplicar». Con JS se envía al cambiar, que es lo que la gente espera.
  document.querySelectorAll('[data-facets]').forEach(function (form) {
    form.addEventListener('change', function () {
      form.submit();
    });
  });

  // El orden viaja en la misma URL que los filtros, así que en vez de un
  // formulario aparte se reescribe el parámetro sobre la dirección actual.
  // Hay dos por página: el del panel lateral y el del cajón de móvil.
  Array.prototype.forEach.call(document.querySelectorAll('[data-sort]'), function (sorter) {
    sorter.addEventListener('change', function () {
      // En la colección y la búsqueda se reordena la página actual. En la
      // portada Shopify no resuelve `sort_by`, así que el selector trae
      // `data-sort-url` y manda a la colección con ese orden.
      var destino = sorter.getAttribute('data-sort-url');
      var url = new URL(destino || window.location.href, window.location.origin);
      url.searchParams.set('sort_by', sorter.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  /* ---------------- Origen del relleno de los botones ---------------- */

  // El círculo del hover crece desde donde entró el cursor: acá solo se
  // anota esa coordenada; el resto lo hace el CSS. Al salir se reescribe
  // con el punto de salida, para que se encoja hacia donde se fue.
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var markOrigin = function (event) {
      var btn = event.target.closest('.btn, .btn-o, .chip');
      // pointerover/out también saltan entre hijos del botón; solo interesa
      // cuando el cursor cruza el borde de verdad.
      if (!btn || btn.contains(event.relatedTarget)) return;

      var box = btn.getBoundingClientRect();
      btn.style.setProperty('--px', event.clientX - box.left + 'px');
      btn.style.setProperty('--py', event.clientY - box.top + 'px');
    };

    document.addEventListener('pointerover', markOrigin);
    document.addEventListener('pointerout', markOrigin);
  }

  /* ---------------- Encabezado fijo ---------------- */

  var header = document.querySelector('[data-sticky-header]');

  if (header) {
    var ticking = false;
    var wrapper = header.closest('.shopify-section') || header;
    var threshold = 0;

    // La sombra aparece cuando el encabezado ya está pegado arriba, o sea al
    // pasar lo que va encima de él (la barra de aviso). No cambia de alto al
    // fijarse (estándar de las tiendas), así que no hay bucle con el scroll.
    var measure = function () {
      var prev = wrapper.previousElementSibling;
      // Nunca bajo 0: sin barra de aviso, lo de arriba es el enlace oculto
      // «saltar al contenido», que se esconde con un top negativo.
      threshold = prev ? Math.max(0, prev.offsetTop + prev.offsetHeight) : 0;
    };

    var updateStuck = function () {
      header.classList.toggle('is-stuck', window.scrollY > threshold);
      ticking = false;
    };

    measure();
    window.addEventListener('resize', measure, { passive: true });

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateStuck);
      },
      { passive: true }
    );

    updateStuck();

    // Su alto queda en --header-h para la barra de filtros de móvil, que va
    // pegada justo debajo. Cambia con el ancho y al fijarse; si el encabezado
    // no es fijo, la barra se pega arriba del todo.
    new ResizeObserver(function () {
      var fijo = getComputedStyle(wrapper).position === 'sticky';
      document.documentElement.style.setProperty('--header-h', (fijo ? wrapper.offsetHeight : 0) + 'px');
    }).observe(wrapper);
  }

  /* ---------------- Slider del hero ---------------- */

  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hero-track]');
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));

      // El CSS esconde el texto solo cuando existe esta clase: si el
      // script nunca corre, el hero se ve completo en vez de quedar en
      // blanco esperando una animación que no va a llegar.
      this.classList.add('is-ready');

      // El primer slide se marca un cuadro después, no de inmediato: el
      // navegador necesita pintar el estado de partida —texto abajo y
      // transparente, imagen sin acercar— para tener desde dónde animar.
      // Va antes de la salida temprana para que un hero de un solo slide
      // también entre con efecto.
      var primero = this.slides[0];
      if (primero) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { primero.classList.add('is-current'); });
        });
      }

      if (!this.track || this.slides.length < 2) return;

      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.ring = this.querySelector('[data-hero-ring]');
      this.count = this.querySelector('[data-hero-count]');
      this.circumference = 2 * Math.PI * 19;
      this.elapsed = 0;
      this.tick = this.tick.bind(this);

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(Number(dot.dataset.heroDot)));
      });

      // El scroll manda: el usuario puede deslizar y los puntos siguen.
      var settle;
      this.track.addEventListener(
        'scroll',
        () => {
          clearTimeout(settle);
          settle = setTimeout(() => this.sync(), 120);
        },
        { passive: true }
      );

      // Donde exista, scrollend avisa el final exacto y evita esperar el timeout
      if ('onscrollend' in window) {
        this.track.addEventListener('scrollend', () => {
          this.seeking = false;
          this.track.style.scrollSnapType = '';
          this.sync();
        });
      }

      this.startAuto();
      ['pointerenter', 'focusin'].forEach((e) => this.addEventListener(e, () => this.stopAuto()));
      ['pointerleave', 'focusout'].forEach((e) => this.addEventListener(e, () => this.startAuto()));
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stopAuto() : this.startAuto();
      });
    }

    disconnectedCallback() {
      this.stopAuto();
      clearTimeout(this.seekTimer);
    }

    get duration() {
      return Number(this.dataset.interval) || 7000;
    }

    go(i) {
      var n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.elapsed = 0;
      this.paintTimer();

      // Marcamos el scroll como propio: mientras dura, sync() no puede
      // pisar el índice con las posiciones intermedias de la animación.
      this.seeking = true;
      clearTimeout(this.seekTimer);
      this.seekTimer = setTimeout(() => {
        this.seeking = false;
        this.track.style.scrollSnapType = '';
      }, 700);

      // scrollIntoView movía TAMBIÉN la página: si el visitante estaba
      // mirando más abajo, cambiar de slide lo devolvía al hero. Movemos
      // solo el carril, y apagamos el snap mientras dura la animación
      // porque si no la interrumpe a medio camino.
      this.track.style.scrollSnapType = 'none';
      this.track.scrollTo({
        left: this.track.clientWidth * this.index,
        behavior: this.reduced ? 'auto' : 'smooth'
      });

      this.paint();
    }

    sync() {
      if (this.seeking) return;
      var w = this.track.clientWidth;
      if (!w) return;
      var i = Math.round(this.track.scrollLeft / w);
      if (i === this.index || i < 0 || i >= this.slides.length) return;
      this.index = i;
      this.paint();
    }

    paint() {
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-current', i === this.index);
      });
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', String(i === this.index));
      });
    }

    /* El avance corre sobre requestAnimationFrame en vez de setInterval:
       así el anillo se anima con el mismo reloj que cuenta el slide, y al
       pausar se conserva el tiempo ya transcurrido en vez de reiniciarlo. */
    tick(now) {
      if (this.last == null) this.last = now;
      this.elapsed += now - this.last;
      this.last = now;

      if (this.elapsed >= this.duration) {
        this.go(this.index + 1);
      } else {
        this.paintTimer();
      }

      this.raf = requestAnimationFrame(this.tick);
    }

    paintTimer() {
      if (!this.ring) return;
      var progress = Math.min(this.elapsed / this.duration, 1);
      this.ring.style.strokeDashoffset = this.circumference * (1 - progress);

      var left = Math.max(1, Math.ceil((this.duration - this.elapsed) / 1000));
      if (this.count && left !== this.shown) {
        this.count.textContent = left;
        this.shown = left;
      }
    }

    startAuto() {
      this.stopAuto();
      if (this.dataset.autoplay !== 'true' || this.reduced) return;
      this.last = null;
      this.raf = requestAnimationFrame(this.tick);
    }

    stopAuto() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
      this.last = null;
    }
  }

  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', HeroSlider);
  }

  /* ---------------- Filtros por etiqueta ---------------- */

  class FilterChips extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section') || document;
      this.grid = this.querySelector('[data-filter-grid]');
      this.empty = this.querySelector('[data-filter-empty]');
      this.chips = Array.from(this.scope.querySelectorAll('[data-filter]'));
      if (!this.grid || !this.chips.length) return;

      this.items = Array.from(this.grid.querySelectorAll('[data-filter-item]'));
      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => this.apply(chip));
      });
    }

    apply(chip) {
      var tag = chip.dataset.filter;

      this.chips.forEach((c) => c.setAttribute('aria-selected', String(c === chip)));

      var visible = 0;
      this.items.forEach((item) => {
        var tags = (item.dataset.tags || '').split(',');
        var match = tag === '*' || tags.indexOf(tag) !== -1;
        item.hidden = !match;
        if (match) visible++;
      });

      if (this.empty) this.empty.hidden = visible > 0;
    }
  }

  if (!customElements.get('filter-chips')) {
    customElements.define('filter-chips', FilterChips);
  }

  /* ---------------- Mini carrito ---------------- */

  // El mismo de telas.cl (sections/cart-drawer.liquid). Se repinta con la
  // misma respuesta de /cart/add.js o /cart/change.js: se le pide a Shopify
  // el HTML de la sección (section rendering) y se reemplaza solo el
  // contenido. Así los montos salen con el formato de moneda de la tienda.
  var miniCarrito = function () { return document.querySelector('[data-cart-drawer]'); };

  var seccionMiniCarrito = function () {
    var el = miniCarrito();
    var seccion = el && el.closest('.shopify-section');
    return seccion ? seccion.id.replace('shopify-section-', '') : null;
  };

  var pintarMiniCarrito = function (secciones) {
    var id = seccionMiniCarrito();
    if (!id || !secciones || !secciones[id]) return false;
    var nuevo = new DOMParser().parseFromString(secciones[id], 'text/html').querySelector('[data-cart-drawer-inner]');
    var actual = document.querySelector('[data-cart-drawer-inner]');
    if (!nuevo || !actual) return false;
    actual.innerHTML = nuevo.innerHTML;
    return true;
  };

  // Quitar una línea sin salir de la página. Sin JavaScript el enlace
  // (`url_to_remove`) hace lo mismo recargando.
  document.addEventListener('click', function (event) {
    var quitar = event.target.closest('[data-cart-remove]');
    if (!quitar || !window.Shopify) return;
    event.preventDefault();
    if (quitar.getAttribute('aria-disabled') === 'true') return;
    quitar.setAttribute('aria-disabled', 'true');

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: quitar.getAttribute('data-cart-remove'),
        quantity: 0,
        sections: [seccionMiniCarrito()],
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        if (!res.ok) throw res;
        return res.json();
      })
      .then(function (cart) {
        pintarMiniCarrito(cart.sections);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        // El enlace apretado ya no existe: el foco vuelve al panel
        var panel = miniCarrito() && miniCarrito().querySelector('.drawer__panel');
        if (panel) panel.focus();
      })
      .catch(function () { window.location.assign(quitar.href); });
  });

  /* ---------------- Agregar al carrito sin recargar ---------------- */

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      if (!this.form) return;
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      if (!window.Shopify || document.body.dataset.cartAjax === 'false') return;
      event.preventDefault();
      if (this.button.hasAttribute('aria-disabled')) return;

      // Solo se cambia la etiqueta, no todo el botón: así el ícono y el
      // texto para lectores de pantalla sobreviven al «Agregado».
      var label = this.button.querySelector('[data-add-label]');
      var original = label ? label.textContent : null;

      this.button.setAttribute('aria-disabled', 'true');

      var datos = new FormData(this.form);
      var seccion = seccionMiniCarrito();
      if (seccion) {
        datos.append('sections', seccion);
        datos.append('sections_url', window.location.pathname);
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: datos
      })
        .then((res) => {
          if (!res.ok) throw res;
          return res.json();
        })
        .then((json) => {
          if (label) label.textContent = label.dataset.added || 'Agregado';
          this.button.classList.add('is-added');
          // Como en telas.cl: después de agregar se abre el mini carrito
          if (pintarMiniCarrito(json.sections)) abrirCajon(miniCarrito(), this.button);
          return this.refreshCart();
        })
        .catch(() => this.form.submit())
        .finally(() => {
          setTimeout(() => {
            this.button.removeAttribute('aria-disabled');
            this.button.classList.remove('is-added');
            if (label && original !== null) label.textContent = original;
          }, 1600);
        });
    }

    refreshCart() {
      return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((res) => res.json())
        .then((cart) => {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        });
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  /* ---------------- Galería de la ficha ---------------- */

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-gallery-main]');
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-thumb]'));
      if (!this.main || !this.thumbs.length) return;

      var self = this;
      this.thumbs.forEach(function (b) {
        b.addEventListener('click', function () { self.show(b); });
      });
    }

    show(boton) {
      this.main.src = boton.dataset.galleryThumb;
      this.thumbs.forEach(function (b) {
        if (b === boton) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  /* ---------------- Formato y cantidad en la ficha ---------------- */

  (function () {
    var seccion = document.querySelector('.pdp');
    if (!seccion) return;

    var datos = document.querySelector('[data-variant-data]');
    var variantes = [];
    try {
      variantes = JSON.parse(datos.textContent);
    } catch (e) {
      return;
    }

    var campoId = seccion.querySelector('[data-variant-id]');
    var precio = seccion.querySelector('[data-price]');
    var ahorro = seccion.querySelector('.pdp__save');

    seccion.addEventListener('change', function (event) {
      var radio = event.target.closest('input[name="pdp-variant"]');
      if (!radio) return;

      var v = variantes.filter(function (x) { return String(x.id) === radio.value; })[0];
      if (!v) return;

      if (campoId) campoId.value = v.id;

      if (precio) {
        // Se rehace el nodo completo: el tachado aparece y desaparece según
        // la variante, no basta con cambiar el texto.
        precio.innerHTML = v.price + (v.on_sale ? '<del data-compare-price>' + v.compare_at_price + '</del>' : '');
      }

      if (ahorro) {
        ahorro.hidden = !v.on_sale;
        if (v.on_sale) ahorro.textContent = ahorro.dataset.label + ' ' + v.save;
      }

      // La URL guarda la variante elegida, igual que en Shopify: así el
      // enlace que alguien copie abre el formato que estaba mirando.
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    });

  })();

  /* ---------------- Cantidad ---------------- */

  /* Sirve a la ficha y al carrito. En el carrito el mínimo es cero, que es
     como Shopify elimina una línea; en la ficha es uno. */
  document.addEventListener('click', function (event) {
    var boton = event.target.closest('[data-qty]');
    if (!boton) return;

    var campo = boton.parentNode.querySelector('input');
    if (!campo) return;

    var minimo = parseInt(campo.getAttribute('min'), 10);
    if (isNaN(minimo)) minimo = 1;

    var valor = parseInt(campo.value, 10);
    if (isNaN(valor)) valor = minimo;

    campo.value = Math.max(minimo, valor + parseInt(boton.dataset.qty, 10));
    campo.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Carrito ---------------- */

  (function () {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    var pendiente = null;

    form.addEventListener('change', function (event) {
      if (!event.target.matches('input[name^="updates["]')) return;

      // Se espera un momento antes de enviar: con los botones de más y menos
      // es normal hacer tres clics seguidos, y cada uno recargaría la página.
      clearTimeout(pendiente);
      pendiente = setTimeout(function () {
        form.requestSubmit
          ? form.requestSubmit(form.querySelector('[data-cart-update]'))
          : form.submit();
      }, 500);
    });
  })();

  /* ---------------- Refresco del contador del carrito ---------------- */

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail;
    var count = document.querySelector('[data-cart-count]');
    if (!count) return;

    count.textContent = cart.item_count;
    count.hidden = cart.item_count === 0;

    var link = count.closest('.hcart');
    if (link) link.setAttribute('aria-label', 'Mi carrito, ' + cart.item_count + ' productos');
  });

})();
